import { useEffect } from "react";
import { clearAppLocalStorage } from "@/lib/auth/clearAppStorage";
import {
  APP_VERSION_STORAGE_KEY,
  CURRENT_APP_VERSION,
} from "@/lib/appVersion";
import { logger } from "@/lib/logger";

const useVersionCheck = () => {
  useEffect(() => {
    const currentVersion = localStorage.getItem("appVersion");

    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json", { cache: "no-store" });
        const { version: latestVersion } = await response.json();

        if (currentVersion && currentVersion !== latestVersion) {
          // New deploy: bust app caches and reload to pick up new assets, but
          // preserve the Auth0 session so a release does not log everyone out
          // (and cannot strand the SDK refresh lock). See LAR-290.
          clearAppLocalStorage();
          sessionStorage.clear();

          if ("caches" in window) {
            const names = await caches.keys();
            await Promise.all(names.map((name) => caches.delete(name)));
          }

          localStorage.setItem("appVersion", latestVersion);
          // Prevent AppProvider's app_version gate from forcing a second reload.
          localStorage.setItem(APP_VERSION_STORAGE_KEY, CURRENT_APP_VERSION);
          window.location.reload();
          return;
        }

        // Keep the stored version current so the next deploy is detected.
        localStorage.setItem("appVersion", latestVersion);
      } catch {
        logger.warn("Version check failed", { operation: "checkVersion" });
      }
    };

    checkVersion();

    const interval = setInterval(checkVersion, 5 * 60 * 1000); // Check every 5 minutes

    return () => clearInterval(interval);
  }, []);
};

export default useVersionCheck;
